import { Table, Typography } from "antd";
import { COMPANY_ROLE_ENUM } from "interfaces";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { label } from "./utils";
import { formatWithDecimals } from "utils";

export const AdditionalFeesBlock = observer(() => {
  const { settings } = useStores();
  const { companyFees, requestFeeSettings } = settings;

  const findFeeSettings = (role: string, direction: "IMP" | "EXP") =>
    requestFeeSettings.find((item) => item.role === role && item.direction === direction);

  const formatPercent = (value: number | null | undefined) =>
    value !== null && value !== undefined ? `${formatWithDecimals(value * 100)} %` : "—";

  const formatRub = (value: number | null | undefined) =>
    value !== null && value !== undefined ? `${formatWithDecimals(value)} руб.` : "—";

  const notCharged = <Typography.Text className="text-description">Не взимается</Typography.Text>;

  const customerImpFees = findFeeSettings(COMPANY_ROLE_ENUM.CUSTOMER, "IMP");
  const customerExpFees = findFeeSettings(COMPANY_ROLE_ENUM.CUSTOMER, "EXP");
  const lpImpFees = findFeeSettings(COMPANY_ROLE_ENUM.LIQUIDITY_PROVIDER, "IMP");
  const lpExpFees = findFeeSettings(COMPANY_ROLE_ENUM.LIQUIDITY_PROVIDER, "EXP");

  const items = [
    {
      key: "customer-import",
      name: "Участник ВЭД (Импорт)",
      baseFee: formatPercent(companyFees.customerBaseFeeImp),
      acquiringFee: formatPercent(customerImpFees?.acquiringFee),
      agentFee: formatPercent(customerImpFees?.agentFee),
      additionalRequestsFee: formatPercent(customerImpFees?.additionalRequestsFee),
      amountDiscount: formatPercent(customerImpFees?.amountDiscount),
      discountThreshold: formatRub(customerImpFees?.discountThreshold),
    },
    {
      key: "customer-export",
      name: "Участник ВЭД (Экспорт)",
      baseFee: formatPercent(companyFees.customerBaseFeeExp),
      acquiringFee: notCharged,
      agentFee: formatPercent(customerExpFees?.agentFee),
      additionalRequestsFee: formatPercent(customerExpFees?.additionalRequestsFee),
      amountDiscount: formatPercent(customerExpFees?.amountDiscount),
      discountThreshold: formatRub(customerExpFees?.discountThreshold),
    },
    {
      key: "lp-import",
      name: "ПЛ (Импорт)",
      baseFee: formatPercent(companyFees.lpBaseFeeImp),
      acquiringFee: notCharged,
      agentFee: notCharged,
      additionalRequestsFee: notCharged,
      amountDiscount: formatPercent(lpImpFees?.amountDiscount),
      discountThreshold: formatRub(lpImpFees?.discountThreshold),
    },
    {
      key: "lp-export",
      name: "ПЛ (Экспорт)",
      baseFee: formatPercent(companyFees.lpBaseFeeExp),
      acquiringFee: formatPercent(lpExpFees?.acquiringFee),
      agentFee: notCharged,
      additionalRequestsFee: notCharged,
      amountDiscount: formatPercent(lpExpFees?.amountDiscount),
      discountThreshold: formatRub(lpExpFees?.discountThreshold),
    },
  ];
  return <Table dataSource={items} columns={label} pagination={false} size="small" />;
});
